/**
 * stripeClient.ts — load Stripe.js once per publishable key (browser only).
 *
 * Never logs the key or Stripe objects. Stub checkout never calls this.
 */
import { loadStripe, type Stripe } from '@stripe/stripe-js';

let cachedKey: string | null = null;
let cachedPromise: Promise<Stripe | null> | null = null;

/** Memoised `loadStripe` for the given publishable key. */
export function getStripePromise(publishableKey: string): Promise<Stripe | null> {
  if (cachedKey === publishableKey && cachedPromise) return cachedPromise;
  cachedKey = publishableKey;
  cachedPromise = loadStripe(publishableKey);
  return cachedPromise;
}

/** Test helper — clears the memo so env changes take effect. */
export function resetStripePromiseCache(): void {
  cachedKey = null;
  cachedPromise = null;
}
